export const Statement = {
    LOADING_STATEMENT_LIST: "LOADING_STATEMENT_LIST",
    GET_STATEMENT_LIST: "GET_STATEMENT_LIST",
  };